import { FormItem } from '../../../commons/Form/Form.types';
import { ContactFormSchema } from './Contact.types';

export const contactData: FormItem<ContactFormSchema>[][] = [
  [
    {
      name: 'firstName',
      placeholder: 'Votre prénom...',
      label: 'Prénom',
      type: 'text',
      required: true,
    },
    {
      name: 'lastName',
      placeholder: 'Votre nom...',
      label: 'Nom',
      type: 'text',
      required: true,
    },
  ],
  [
    {
      name: 'email',
      placeholder: 'Votre adresse email...',
      label: 'Adresse email',
      type: 'text',
      required: true,
    },
  ],
  [
    {
      name: 'subject',
      placeholder: 'Objet de votre message...',
      label: 'Objet',
      type: 'text',
      required: true,
    },
  ],
  [
    {
      name: 'message',
      placeholder: 'Votre message...',
      label: 'Message',
      type: 'textarea',
      required: true,
      style: {
        height: 80,
      },
    },
  ],
];
